export enum JobLifecycle {
    STARTED = 'started',
    FINISHED = 'finished',
    FAILED = 'failed',
}
